import { createFileRoute } from "@tanstack/react-router"

import { GuidePage } from "../../components/landing"
import { gstGuideZh } from "../../content/zh/gst-calculator"
import { guideSeo } from "../guides.$slug"

const PATH = "/gst-calculator"

/** Chinese version of /gst-calculator (D-WEB-LANG-SCOPE, T1320); the English route carries the hreflang pair too. */
export const gstZhSeo = () => guideSeo(gstGuideZh, PATH, "zh")

export const Route = createFileRoute("/_brand-layout/zh/gst-calculator")({
  head: () => {
    const { meta, links, scripts } = gstZhSeo()
    return { meta, links, scripts }
  },
  component: GstZhPage,
})

export function GstZhPage() {
  return <GuidePage guide={gstGuideZh} />
}
